// store/index.js
import { createStore } from "vuex"

export default createStore ({
    state: {
      jury: null,
      candidates: [],
      selectedCandidate: null,
      criteriasByCategory: [],
    },
    mutations: {
      setJury(state, jury) {
        state.jury = jury;
      },
      setCandidates(state, candidates) {
        state.candidates = candidates;
      },
      setSelectedCandidate(state, candidate) {
        state.selectedCandidate = candidate;
      },
      setCriteriasByCategory(state, criterias) {
        state.criteriasByCategory = criterias;
      },
    },
    actions: {
      updateJury({ commit }, jury) {
        commit('setJury', jury);
      },
      updateCandidates({ commit }, candidates) {
        commit('setCandidates', candidates);
      },
      updateSelectedCandidate({ commit }, candidate) {
        commit('setSelectedCandidate', candidate);
      },
      updateCriteriasByCategory({ commit }, criterias) {
        commit('setCriteriasByCategory', criterias);
      },
      logout({ commit }) {
        // Clear all state data on logout
        commit('setJury', null);
        commit('setSelectedCandidate', null);
      },
    },
  });
  